module.exports = __webpack_public_path__ + "img/pto.44bfde33.svg";